/* eslint-disable @typescript-eslint/naming-convention */

export const pegTypeEnumMap = {
    PRIM: 'Prim',
    PRIM_DISC: 'Prim Disc',
    MID: 'Mid',
    MID_DISC: 'Mid Disc',
    MKT: 'Mkt',
    MKT_DISC: 'Mkt Disc',
    BEST: 'Best',
    BEST_DISC: 'Best Disc',
    LAST: 'Last',
    LAST_DISC: 'Last Disc',
    VWAP: 'Vwap',
    NEAR: 'Near',
    MIN_PX_IMPROVEMENT: 'Min Price Improvement',
    CONTRA_MIDPEG: 'Contra Mid Peg',
    CONTRA_MIDPEGDARK: 'Contra Mid Peg Dark',
    NONE: 'None',
    NO_DATA_VALUE: 'No Data',
};
